import React from 'react'

const ChartLegends = ({devices, updateDevices, id}) => {
    return (
        <div className='legends_container'>
            {devices.map((device) => (
                <button
                    key={id + device.label}
                    onClick={() => {
                        const updatedDevices = devices.map((d) =>
                            d.label === device.label ? { ...d, visible: !d.visible } : d
                        );
                        updateDevices(updatedDevices);
                    }}
                    style={{filter: device.visible ? '' : 'opacity(0.5)'}}
                >
                    <span style={{ backgroundColor: device.color }}></span>
                    <span>{device.label}</span>
                </button>
            ))}
        </div>
    )
}

export default ChartLegends